if ($(".id--9").length) {
  function mhProductInfoMove() {
    const hasDiscount = $('.cart-table tr.removeable [data-testid="cartItemDiscount"]').length > 0;
    const tableHeadMarkup = `
      <thead>
        <tr>
          <th colspan="2">Produkt</th>
          <th>Dostupnost</th>
          <th>Počet</th>
          <th>Cena za m. j.</th>
          ${hasDiscount ? "<th>Sleva</th>" : ""}
          <th><span>Celkem</span></th>
        </tr>
      </thead>
    `;

    if (!$(".cart-table thead").length) {
      $(".cart-table tbody").before(tableHeadMarkup);
    } else {
      $(".cart-table thead").replaceWith(tableHeadMarkup);
    }
    const deliveryDates = [];
    $(".cart-table tr").each(function () {
      var findcenazakus = $(this).find(".p-price.p-cell").html();
      var findptotal = $(this).find(".p-total");
      if (findcenazakus && !$(findptotal).find(".cenazaks").length) {
        $(findptotal).prepend('<span class="cenazaks">' + findcenazakus + "</span>");
      }
      if ($(this).find(".main-link-variant").length) {
        $(this)
          .find(".main-link-variant")
          .each(function () {
            const $el = $(this);
            const text = $el.text();

            const parts = text.split(", ");

            const result = parts
              .map((part, index) => {
                const idx = part.indexOf(":");
                const separator = index < parts.length - 1 ? ' <span class="superLabelSeparator">|</span>' : "";

                if (idx !== -1) {
                  const label = part.substring(0, idx + 1); // včetně :
                  const rest = part.substring(idx + 1);

                  return `<span class="superLabel"><b>${label}</b>${rest}${separator}</span>`;
                }

                return `<span class="superLabel">${part}${separator}</span>`;
              })
              .join(" ");

            $el.html(result);
          });
      }

      const $row = $(this);

      if ($row.hasClass("removeable") && hasDiscount) {
        const $discountEl = $row.find('[data-testid="cartItemDiscount"]');

        if ($discountEl.length) {
          const title = $discountEl.attr("title") || $discountEl.attr("data-original-title") || "";

          const percentMatch = title.match(/([\d.,]+)\s?%/);
          const percent = percentMatch ? Math.round(parseFloat(percentMatch[1].replace(",", "."))) : 0;

          const oldPriceMatch = title.match(/ze standardní ceny\s*([\d\s.,]+)\s*Kč/i);

          const oldPrice = oldPriceMatch ? parseFloat(oldPriceMatch[1].replace(/\s/g, "").replace(",", ".")) : 0;

          if (oldPrice > 0 && !$row.find(".p-total .oldPrice").length) {
            $row.find(".p-total").prepend('<span class="oldPrice">' + oldPrice + " Kč</span>");
          }

          if (percent > 0) {
            if (!$row.find(".p-total .sale-percent").length) {
              $row.find(".p-total").append(`
          <span class="sale-percent">-${percent} %</span>
        `);
            }

            if (!$row.find(".p-sale").length) {
              $row.find(".p-total").before(`
          <td class="p-sale">
            <span class="sale-percent">${percent} %</span>
          </td>
        `);
            }
          } else {
            if (!$row.find(".p-sale").length) {
              $row.find(".p-total").before('<td class="p-sale"></td>');
            }
          }
        } else {
          if (!$row.find(".p-sale").length) {
            $row.find(".p-total").before('<td class="p-sale"></td>');
          }
        }
      }

      $(this).find(".availability-amount").attr("style", $(this).find(".availability-label").attr("style"));

      const availabilityText = $(this).find(".availability-label").text().trim().toLowerCase();

      const deliveryDate = getDeliveryDateByAvailability(availabilityText);
      if (!deliveryDate) return;
      deliveryDates.push(deliveryDate);
      const formatted = formatDeliveryDate(deliveryDate, true);

      $(this).find(".p-availability ").append(`<div class="deliveryDate">můžeme doručit do ${formatted}</div>`);
      $(this).find(".p-availability").wrapInner(`<div class="availabilityWrapper"></div>`);
      $(this).find(".availabilityWrapper").wrapInner(`<div class="availabilityWrapperInner"></div>`);
      $(this).find(".p-availability").addClass(availabilityText);
    });

    if (deliveryDates.length) {
      const latestDate = deliveryDates.map((d) => new Date(d)).reduce((latest, current) => (current > latest ? current : latest));

      sessionStorage.setItem("latestDeliveryDate", latestDate.toISOString());
      const formatted = latestDate.toLocaleString("cs-CZ", {
        day: "numeric",
        month: "numeric",
        year: "numeric",
      });

      if (!$(".summary-wrapper .price-wrapper .maxDelivery").length) {
        $(".summary-wrapper .price-wrapper").append(
          `<div class="maxDelivery price-label price-secondary">Doručení možné do:</div>
          <div class="maxDelivery price price-secondary">${formatted}</div>`,
        );
      }
    }

    $(".free-gift").each(function () {
      $(this).find("label").append($(this).find(".btn.btn-secondary.free-gift-trigger").clone());
    });

    if ($(".applied-coupon").length) {
      $(".discount-coupon").addClass("activeCoupon");
    }
    if ($(".next-step .next-step-back").length) {
      var backStep = $(".next-step .next-step-back").attr("href");
    } else {
      var backStep = "/";
    }
    $(".col-md-8>.cart-content").append('<div class="flexik"><div class="left"><div class="backStep"><a href="' + backStep + '">Zpět do obchodu</a></div></div><div class="backStep"><a href="' + backStep + '">Zpět do obchodu</a></div></div>');

    $(".cart-row .col-md-8 .flexik .left").append($(".cart-content>.cart-summary .discount-coupon").clone());

    $(".sidebar-in-cart .summary-wrapper").appendTo($(".cart-row .col-md-8 .flexik"));

    $(".flexik .left .discount-coupon").before(`
        <input type="checkbox" id="discount-checkbox">
            <label for="discount-checkbox">
                Mám slevový kód
            </label>
        `);
    $("#discount-checkbox").on("change", function () {
      $(".discount-coupon").toggleClass("active", this.checked);
    });
    if ($('.discount-coupon button[type="submit"][data-testid="buttonSubmitDiscountCoupon"]').length) {
      $('.discount-coupon button[type="submit"][data-testid="buttonSubmitDiscountCoupon"]').text(translation("uplatnitKod"));
    }
    if ($(".discount-coupon .applied-coupon").length) {
      $(".discount-coupon").addClass("active");
      $("#discount-checkbox").prop("checked", true);
      $('input[data-testid="buttonRemoveDiscountCoupon"]').attr("value", "Odebrat kupon");
    }
  }
  $(document).ready(function () {
    mhProductInfoMove();
    updateFreeShippingBox(".flexik .left");
  });

  document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    mhProductInfoMove();
    updateFreeShippingBox(".flexik .left");
  });
}

if ($(".id--9").length) {
  function emptyFooter() {
    $("h1").text("Nákupní košík je prázdný");
    $(".cart-empty .cart-row, .empty-cart-boxes .cart-row").html($("footer#footer .emptyCartPage"));
    $(".cart-row").after($("footer#footer .contact-wrap").clone());
    $(".custom-footer__contact .contact-box").clone().appendTo(".contact-wrap");
    $(".contact-wrap").wrap('<div class="contact-wrap-wrapper"></div>');
    $(".contact-wrap-wrapper").append($("footer .helpCartEmptyPage").clone());
    applyOpenHoursState();
    $(".cart-empty").append('<div class="lastWiewProducts "></div>');
    $(".lastWiewProducts").prepend('<div class="homepage-group-title h4 text-center">Naposledy procházené produkty <a href="/naposledy-prohlizene/">Všechny produkty</a></div>');
  }
  if ($(".cart-empty, .empty-cart-boxes").length) {
    loadFooter(function () {
      emptyFooter();
      getCategories();
      getFavouriteProductsList();
    });
  }
  document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    if ($(".cart-empty, .empty-cart-boxes").length) {
      loadFooter(function () {
        emptyFooter();
        getCategories();
        getFavouriteProductsList();
      });
    }
  });
}

document.addEventListener("UpsellCartRendered", function () {
  $(".up-product").each(function () {
    $(this).find(".product-url-image-full-size").append($(this).find(".up-product-add-to-cart"));
    if ($(this).find(".up-price-common-percentage").length) {
      $(this).find(".product-url-image-full-size").append($(this).find(".up-price-common-percentage"));
    }
    const availabilityText = $(this).find(".up-in-stock-label").text().trim().toLowerCase();

    const deliveryDate = getDeliveryDateByAvailability(availabilityText);
    if (!deliveryDate) return;

    const formatted = formatDeliveryDate(deliveryDate);

    if (!$(this).find(".deliveryDate").length) {
      $(this).find(".up-in-stock-label").append(`<span class="deliveryDate">, ${formatted} u tebe</span>`);
    }
  });
});
